import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["tagIds"],
  _excluded2 = ["accountId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { adminApiRoutes } from './routes';
export class AdminApi {
  constructor() {
    _defineProperty(this, "routes", adminApiRoutes);
  }
  async getCompaniesList(body, options) {
    const tagIds = body.tagIds,
      rest = _objectWithoutProperties(body, _excluded);
    const params = new URLSearchParams();
    Object.keys(rest).forEach(function (key) {
      if (rest[key] !== undefined) params.append(key, rest[key] ? rest[key] : '');
    });
    if (tagIds && tagIds.length) {
      tagIds.split('&').map(i => {
        params.append('tagIds', i);
      });
    }
    const resp = await requestService('property').get(this.routes.companies, _objectSpread({
      params: params
    }, options.cancelToken));
    return resp.data;
  }
  async createPMAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.createAccount, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createCompany(body, options) {
    const resp = await requestService('property').post(this.routes.companies, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyById(data, options) {
    const resp = await requestService('property').get(this.routes.company(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAdminAccountImpersonate(body, options) {
    const companyId = body.companyId;
    const resp = await requestService('auth').get(this.routes.loginImpersonate({
      companyId
    }), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createAdminAccount(body, options) {
    const resp = await requestService('auth').post(this.routes.baseUrl, _objectSpread(_objectSpread({}, body), options.cancelToken));
    return resp.data;
  }
  async getAdminAccounts(options) {
    const resp = await requestService('auth').get(this.routes.adminAccounts, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteAdminAccount(body, options) {
    const accountId = body.accountId;
    const resp = await requestService('auth').delete(this.routes.deleteAdmin({
      accountId
    }), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateAdminAccount(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('auth').put(this.routes.updateAdmin(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}